(function () {
    const body = document.body;
    const navbar = document.querySelector('.navbar');
    const burgers = document.querySelectorAll('.navbar-burger');
    const navbarMenu = document.getElementById('primaryMenu');

    // Mobile menu toggle
    function toggleMobileMenu(forceClose = false) {
        const isActive = navbarMenu.classList.contains('is-active');

        if (forceClose || isActive) {
            burgers.forEach((burger) => burger.classList.remove('is-active'));
            navbarMenu.classList.remove('is-active');
            body.classList.remove('has-navbar-open');
        } else {
            burgers.forEach((burger) => burger.classList.add('is-active'));
            navbarMenu.classList.add('is-active');
            body.classList.add('has-navbar-open');
        }
    }

    burgers.forEach((burger) => {
        burger.addEventListener('click', () => toggleMobileMenu());
    });

    // Close mobile menu when clicking a nav link
    const navLinks = document.querySelectorAll('.navbar-menu .navbar-item');
    navLinks.forEach((link) => {
        link.addEventListener('click', () => toggleMobileMenu(true));
    });

    // Close menu on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            toggleMobileMenu(true);
        }
    });

    // Navbar scroll effect
    let lastScrollTop = 0;
    const scrollThreshold = 50;

    function handleScroll() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        if (scrollTop > scrollThreshold) {
            navbar.classList.add('is-scrolled');
        } else {
            navbar.classList.remove('is-scrolled');
        }

        lastScrollTop = scrollTop;
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    // Active navbar item based on current page
    const currentPath = window.location.pathname;
    navLinks.forEach((link) => {
        const href = link.getAttribute('href');
        if (href && currentPath.includes(href.replace(/\/$/, ''))) {
            link.classList.add('is-active');
        }
    });

    // Scroll animations using IntersectionObserver
    const animatedElements = document.querySelectorAll('.fade-in, .section, .card, .box');

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('is-visible');
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px',
            }
        );

        animatedElements.forEach((el) => {
            el.classList.add('animate-on-scroll');
            observer.observe(el);
        });
    } else {
        // Fallback for older browsers
        animatedElements.forEach((el) => el.classList.add('is-visible'));
    }

    // Gallery expand buttons
    const galleryExpandBtns = document.querySelectorAll('.gallery-expand-btn');
    galleryExpandBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = btn.getAttribute('href');
            const galleryFull = document.querySelector(targetId);

            if (galleryFull) {
                galleryFull.classList.remove('hidden');
                btn.style.display = 'none';
            }
        });
    });
})();
